import * as Yup from 'yup'

export function ValidateAddUser(values) {
    return Yup.object().shape({
        system_role_id: Yup.string().required('This field is required'),
        type_profile: Yup.string().required('This field is required'),
        fullname: Yup.string().required('This field is required'),
        email: Yup.string().email('Please enter a valid email').required('This field is required'),
        password: Yup.string().required('This field is required').min(6, 'Password should be 6 chars minimum.'),
        country: Yup.string().required('This field is required'),
        status: Yup.string().required('This field is required'),
    });
}

export function ValidateUpdateUser(values) {
    return Yup.object().shape({
        system_role_id: Yup.string().required('This field is required'),
        type_profile: Yup.string().required('This field is required'),
        fullname: Yup.string().required('This field is required'),
        email: Yup.string().email('Please enter a valid email').required('This field is required'),
        country: Yup.string().required('This field is required'),
        status: Yup.string().required('This field is required'),
        password: Yup.string().when("is_password", {
            is: (is_password) => is_password==1,
            then: Yup.string().required('This field is required').min(6, 'Password should be 6 chars minimum.'),
        }),
    });
}


export function ValidateUpdateAccount(values) {
    return Yup.object().shape({
        type_profile: Yup.string().required('This field is required'),
        fullname: Yup.string().required('This field is required'),
        email: Yup.string().email('Please enter a valid email').required('This field is required'),
        password: Yup.string().when("is_password", {
            is: (is_password) => is_password==1,
            then: Yup.string().required('This field is required').min(6, 'Password should be 6 chars minimum.'),
        }),
    });
}
